export default __webpack_public_path__ + "static/media/slider_image_03-sm@1x.61afc785.webp";